export default "__VITE_ASSET__CQdbhLgJ__"